import React from "react";
import { Paper, Box, Flex, Text, Button, LoadingOverlay } from "@mantine/core";
import { TblAttributeModel } from "../../../model/TblAttributeModelFix";

interface AttributeFilterBarProps {
  attributeList: TblAttributeModel[];
  attrIdParam: string | null;
  loadingAttributes: boolean;
  onSelectAttribute: (attrId: number) => void;
}

export const AttributeFilterBar: React.FC<AttributeFilterBarProps> = ({
  attributeList,
  attrIdParam,
  loadingAttributes,
  onSelectAttribute,
}) => {
  return (
    <Paper p="sm" bg="gray.0" withBorder style={{ borderRadius: 6 }} mb="md">
      <Box style={{ position: "relative" }}>
        <LoadingOverlay visible={loadingAttributes} overlayProps={{ blur: 1 }} />
        <Flex align="center" wrap="wrap" gap="xs">
          <Text fw={700} size="sm" style={{ whiteSpace: "nowrap" }}>
            Chọn :
          </Text>

          {attributeList.length === 0 ? (
            <Text size="sm" c="dimmed" style={{ fontStyle: "italic" }}>
              (Danh mục này chưa được gán thuộc tính nào)
            </Text>
          ) : (
            attributeList.map((attr) => {
              const isSelected = attrIdParam && Number(attrIdParam) === Number(attr.id);
              return (
                <Button
                  key={attr.id}
                  size="sm"
                  variant={isSelected ? "filled" : "outline"}
                  color={isSelected ? "orange" : "blue"}
                  style={{
                    backgroundColor: isSelected ? "#fff3bf" : undefined,
                    borderColor: isSelected ? "#f59f00" : undefined,
                    color: isSelected ? "#d9480f" : undefined,
                    fontWeight: isSelected ? 700 : 500,
                  }}
                  onClick={() => onSelectAttribute(attr.id)}
                >
                  {attr.attributeName}
                </Button>
              );
            })
          )}
        </Flex>
      </Box>
    </Paper>
  );
};
